// extracted by mini-css-extract-plugin
export default {"headingBar":"styles_headingBar__qIrBY","tableHead":"styles_tableHead__T1tjO","inputStyle":"styles_inputStyle__oDUJn"};